import React from 'react'
import { Route } from 'react-router-dom'
import InquiryDefaultsIndex from './inquiry-defaults-index'
import InquiryDefaultsResource from './inquiry-defaults-resource'

const InquiryDefaultsRouter = () => {
  return (
    <>
      <Route path="/ui/inquiry-defaults" element={<InquiryDefaultsIndex />} />
      <Route
        path="/ui/inquiry-defaults/:id/:action"
        element={<InquiryDefaultsResource />}
      />
      <Route
        path="/ui/inquiry-defaults/:action"
        element={<InquiryDefaultsResource />}
      />
    </>
  )
}

export default InquiryDefaultsRouter
